module.exports = __webpack_public_path__ + "fonts/interactive.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/interactive.eot
// module id = 56
// module chunks = 0